export default function LocalMap() {
  return (
    <div className="absolute inset-0 bg-white">
      <iframe
        title="Example search radius map of SoHo, Manhattan (OpenStreetMap)"
        src="https://www.openstreetmap.org/export/embed.html?bbox=-74.0105%2C40.7175%2C-73.9915%2C40.7295&amp;layer=mapnik"
        className="absolute inset-0 w-full h-full border-0 pointer-events-none"
        style={{ filter: 'grayscale(1) contrast(1.08) brightness(1.04)' }}
        tabIndex={-1}
      />
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center" aria-hidden="true">
        <div className="relative w-[46%] aspect-square rounded-full bg-accent-500/25 border border-dashed border-accent-600 map-breathe" />
        <div className="absolute w-3.5 h-3.5 rounded-full bg-foreground-950 ring-4 ring-white" />
      </div>
    </div>
  );
}